import { render, staticRenderFns } from "./BulkActionButton.vue?vue&type=template&id=61bf305c&"
import script from "./BulkActionButton.vue?vue&type=script&lang=js&"
export * from "./BulkActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports